import { useQuery } from '@tanstack/react-query';

export enum MigrationStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum BillingType {
  FIXED = 'FIXED',
  PER_UNIT = 'PER_UNIT',
}

export type Company = {
  id: string;
  name: string;
  tenantName: string;
  fcaFirmReferenceNumbers?: { id: string; number: string }[];
  finioFirmName?: string | null;
  isInternal: boolean;
  clientsCount: number;
  migrationStatus: MigrationStatus;
  billingType?: BillingType | null;
  billingAmount?: number | null;
  monthlyBillPence?: number | null;
  activeClientsCount: number;
};

export const useCompanies = () => {
  const { data, isLoading, isError, error } = useQuery<Company[]>({
    queryKey: ['admin', 'companies'],
  });

  return {
    companies: data,
    isLoading,
    isError,
    error,
  };
};
